import * as React from 'react';
import { ReportEnum } from 'types/Reports';
import { PageEnum, PageTypeEnum } from 'store/remote/types';
import { Main as ReportCheckSchedulePage } from './Reports/ReportCheckSchedule/Main';
import { Main as ReportCheckCompletedPage } from './Reports/ReportCheckCompleted/Main';
import { Main as ReportCheckStatusPage } from './Reports/ReportCheckStatus/Main';
import { Main as ReportElementsPage } from './Reports/ReportElements/Main';
import { Main as ReportAssetsPage } from './Reports/ReportAssets/Main';
import { DrawerScreenProps } from '@react-navigation/drawer';
import { PageUnknown } from './Pages/PagesUnknown/PageUnknown';
import { EngageScreen } from 'screens/EngageScreen/EngageScreen';
import { TabOfflineScreen } from 'screens/TabScreen/TabOfflineScreen';
import { AssessmentListScreen } from 'screens/AssessmentsTab/AssessmentListScreen';
import { MainDrawerParamList } from 'components/Navigation/types';
import { TasksAssignedScreen } from 'screens/TasksScreen/TasksAssignedScreen';
type Props = DrawerScreenProps<MainDrawerParamList>;

export const PageSwitch: React.FC<Props> = ({ route: { params } }) => {
  if (params.type === PageTypeEnum.report) {
    if (params.config.type === ReportEnum.checkschedule) {
      return <ReportCheckSchedulePage reportKey={params.key} />;
    }
    if (params.config.type === ReportEnum.checkscompleted) {
      return <ReportCheckCompletedPage reportKey={params.key} />;
    }
    if (params.config.type === ReportEnum.checkstatus) {
      return <ReportCheckStatusPage reportKey={params.key} />;
    }
    if (params.config.type === ReportEnum.elements) {
      return <ReportElementsPage reportKey={params.key} />;
    }
    if (params.config.type === ReportEnum.assets) {
      return <ReportAssetsPage reportKey={params.key} />;
    }
  } else if (params.type === PageTypeEnum.page) {
    if (params.config.type === PageEnum.downloadedProperties) {
      return <TabOfflineScreen inPages={true} />;
    }
    if (params.config.type === PageEnum.engage) {
      return <EngageScreen pageKey={params.key} />;
    }
    if (params.config.type === PageEnum.assessments) {
      return <AssessmentListScreen />;
    }
    if (params.config.type === PageEnum.tasksAssigned) {
      return <TasksAssignedScreen pageKey={params.key} />;
    }
  }
  return <PageUnknown />;
};
